import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
  ElementRef,
} from "@angular/core";
import moment from "moment-timezone";
@Component({
  selector: "evrideo-date-time-picker",
  templateUrl: "./date-time-picker.component.html",
  styleUrls: ["./date-time-picker.component.scss"],
})
export class DateTimePickerComponent implements OnInit, OnChanges {
  @Input() date: moment.Moment;
  @Input() dateFormat = "DD/MM/Y HH:mm";
  @Input() toLocalTime = true;
  @Input() allowEdit = true;
  @Output() dateChanged = new EventEmitter<moment.Moment>();
  jsDate: Date;
  internalDate: moment.Moment;
  showPickers = false;

  constructor(private ref: ElementRef) {}

  ngOnInit() {
    if (!this.date) {
      this.date = moment();
    }
    this.updateInternalDate();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["date"]) {
      if (
        changes["date"].previousValue &&
        (changes["date"].currentValue as moment.Moment).valueOf() !==
          (changes["date"].previousValue as moment.Moment).valueOf()
      ) {
        this.updateInternalDate();
      }
    }
  }

  updateInternalDate() {
    this.internalDate = this.date.clone();
    if (this.toLocalTime) {
      const newDate = moment.tz(this.internalDate.valueOf(), moment.tz.guess());
      this.internalDate = newDate;
    }
    this.jsDate = this.internalDate.toDate();
  }

  togglePickers() {
    this.showPickers = !this.showPickers;
  }
  closePickers() {
    this.showPickers = false;
  }

  getFormatedDate() {
    return this.internalDate.format(this.dateFormat);
  }

  onDateChanged(event: Date) {
    if (event) {
      this.internalDate = this.internalDate.set({
        date: event.getDate(),
        month: event.getMonth(),
        year: event.getFullYear(),
      });
      this.pushUpdatedDate();
    }
  }

  onTimeChanged(event: moment.Moment) {
    if (event) {
      this.internalDate = this.internalDate.set({
        hours: event.hours(),
        minutes: event.minutes(),
        seconds: 0,
      });
      this.pushUpdatedDate();
    }
  }

  pushUpdatedDate() {
    this.dateChanged.emit(this.internalDate.clone().utc());
  }

  onClickOutside(event) {
    if (!this.ref.nativeElement.contains(event.target)) {
      if (this.showPickers) {
        this.showPickers = false;
      }
    }
  }
}
